import React from "react";
import { colorFromString } from "../../utils/ColorFromString";

const Avatar = ({ name, size = 34 }: { name: string; size?: number }) => (
  <span
    className="rounded-circle d-inline-flex align-items-center justify-content-center text-white fw-bold flex-shrink-0"
    style={{ width: size, height: size, background: colorFromString(name || "?"), fontSize: size * 0.4 }}
  >
    {(name || "?").slice(0, 1)}
  </span>
);

export default Avatar;
